// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"de951a4f","214":"007c6da9","822":"58362fbc","898":"e1ef10cf","938":"0245e3da","962":"051ba651","976":"b63899ad"}[chunkId] + ".chunk.js";
};